<script>
    import { onMount, onDestroy } from "svelte";
    import windows from "../../stores/windows.js";
    import food from "../../stores/food.js";
    import journal from "../../stores/journal.js";
    import Scroll from "../windows/Scroll.svelte";

    export let window;

    $: current = $food.all[$food.indexForCurrent];

    $: current &&
        current.reviews?.length &&
        journal.remember(`found interesting food place called "${current.name} (${current.reviews.at(-1).text})"`);

    function didClickImage(index) {
        const id = windows.open("photo", {
            photos: current.photos.map((url) => ({
                url,
                title: current.title
            })),
            index,
            z: window.z
        });

        windows.focus(id);
    }

    onMount(() => {
        food.enable();
    });

    onDestroy(() => {
        const isFoodClosed = $windows.every(({ kind, isClosed }) => kind !== "food" || isClosed);

        if (isFoodClosed) {
            food.disable();
        }
    });
</script>

{#if current}
    <Scroll isFocused={window.isFocused}>
        <h3>{current.name}</h3>
        <address class="selectable">{current.address}</address>
        <div class="photos">
            {#each current.photos as photo, index}
                <img src={photo} on:click={() => didClickImage(index)} alt={current.name} />
            {/each}
        </div>
        <ul class="reviews">
            {#each (current.reviews || []).filter(Boolean).slice(0, 1) as review}
                <li>
                    <div class="rating">
                        {#each Array(Math.round(review.rating)) as _}★{/each}
                    </div>
                    <div class="text selectable">{review.text}</div>
                </li>
            {/each}
        </ul>
        <p><span>From Local</span></p>
    </Scroll>
{:else if $food.isLoading}
    <div>
        <p>Looking for food...</p>
    </div>
{:else}
    <div>
        <p>Nothing found.</p>
    </div>
{/if}

<style>
    div {
        padding: var(--chrome-depth);
    }

    span {
        color: gray;
    }

    .photos {
        grid-gap: var(--chrome-depth);
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        margin: 0;
        margin-top: var(--spacing);
        padding: 0;
    }

    .photos img {
        display: block;
        cursor: pointer;
        background: var(--chrome-hsl);
        aspect-ratio: 1;
        width: 100%;
        object-fit: cover;
    }

    .reviews {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }

    .reviews li {
        margin-top: calc(var(--spacing) * 2);
    }

    .reviews li .rating {
        color: goldenrod;
        line-height: 80%;
        letter-spacing: 2px;
    }
</style>
